import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVector = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} fill='none' {...props}>
    <path d='M18 0V18H0V0H18Z' fill='white' fillOpacity='0.01' />
    <path
      d='M11.625 8.625L7.875 12M7.83333 12.125C8.37894 13.0726 10.9927 14.614 12.5648 15.4806C13.1576 15.8074 13.8833 15.4432 13.9934 14.7754L15.6026 5.01866C15.6666 4.63043 15.2779 4.32378 14.9152 4.47648L2.56499 9.67659C2.16137 9.84653 2.15794 10.4088 2.56346 10.5741C4.00987 11.1638 6.56238 12.125 7.83333 12.125Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgVector;
